import {
  FETCH_EMPLOYEE_ATTENDANCE_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE,
} from "../constants/EmployeeAttendanceConstants";

import EmployeeAttendanceService from "../service/EmployeeAttendanceService";

export const fetchEmployeeAttendance = (date, divisionCode) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_ATTENDANCE_REQUEST });

    const data = await EmployeeAttendanceService.getAll(date, divisionCode);

    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchEmployeeAttendanceEmployees = (date, location, divisionCode) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST });

    const data = await EmployeeAttendanceService.getEmpByLocation(date, location, divisionCode);

    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
